<div class="container-fluid p-0">
  <div class="row">
    <div class="col-12">
      <div class="login-card">
        <div>
          <div>
            <a class="logo" routerLink="/">
              <img
                class="img-fluid for-light"
                src="assets/images/logo/logo.png"
                alt="paginadelogin"
              />
              <img
                class="img-fluid for-dark"
                src="assets/images/logo/logo_dark.png"
                alt="paginadelogin"
              />
            </a>
          </div>
          <div class="login-main">
            <form class="theme-form" [formGroup]="registerForm">
              <h4>Criar Conta</h4>
              <p>Preencha os dados para criar sua conta</p>

              <div class="row">
                <div class="form-group col-md-6 mb-4">
                  <label class="col-form-label">Nome Completo</label>
                  <input
                    class="form-control rounded-pill"
                    type="text"
                    required
                    placeholder="Digite seu nome completo"
                    formControlName="nome"
                  />
                  <div
                    *ngIf="
                      registerForm.controls.nome.touched &&
                      registerForm.controls.nome.errors?.required
                    "
                    class="text text-danger mt-1"
                  >
                    Nome é obrigatório
                  </div>
                  <div
                    *ngIf="
                      registerForm.controls.nome.touched &&
                      registerForm.controls.nome.errors?.maxlength
                    "
                    class="text text-danger mt-1"
                  >
                    Nome deve ter no máximo 255 caracteres
                  </div>
                </div>
                <div class="form-group col-md-6 mb-4">
                  <label class="col-form-label">Usuário</label>
                  <input
                    class="form-control rounded-pill"
                    type="text"
                    required
                    placeholder="Digite um nome de usuário"
                    formControlName="login"
                  />
                  <div
                    *ngIf="
                      registerForm.controls.login.touched &&
                      registerForm.controls.login.errors?.required
                    "
                    class="text text-danger mt-1"
                  >
                    Usuário é obrigatório
                  </div>
                  <div
                    *ngIf="
                      registerForm.controls.login.touched &&
                      registerForm.controls.login.errors?.maxlength
                    "
                    class="text text-danger mt-1"
                  >
                    Usuário deve ter no máximo 255 caracteres
                  </div>
                  <div
                    *ngIf="
                      registerForm.controls.login.touched &&
                      registerForm.controls.login.errors?.pattern
                    "
                    class="text text-danger mt-1"
                  >
                    Usuário não pode conter espaços
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="form-group col-md-6 mb-4">
                  <label class="col-form-label">Email</label>
                  <input
                    class="form-control rounded-pill"
                    type="email"
                    required
                    placeholder="Digite seu email"
                    formControlName="email"
                  />
                  <div
                    *ngIf="
                      registerForm.controls.email.touched &&
                      registerForm.controls.email.errors?.required
                    "
                    class="text text-danger mt-1"
                  >
                    Email é obrigatório
                  </div>
                  <div
                    *ngIf="
                      registerForm.controls.email.touched &&
                      registerForm.controls.email.errors?.email
                    "
                    class="text text-danger mt-1"
                  >
                    Email inválido
                  </div>
                  <div
                    *ngIf="
                      registerForm.controls.email.touched &&
                      registerForm.controls.email.errors?.maxlength
                    "
                    class="text text-danger mt-1"
                  >
                    Email deve ter no máximo 200 caracteres
                  </div>
                </div>
                <div class="form-group col-md-6 mb-4">
                  <label class="col-form-label">Telefone</label>
                  <input
                    class="form-control rounded-pill"
                    type="text"
                    placeholder="Digite seu telefone"
                    formControlName="telefone"
                    mask="(00) 00000-0000"
                  />
                  <div
                    *ngIf="
                      registerForm.controls.telefone.touched &&
                      registerForm.controls.telefone.errors?.required
                    "
                    class="text text-danger mt-1"
                  >
                    Telefone é obrigatório
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="form-group col-md-6 mb-4">
                  <label class="col-form-label">CPF ou CNPJ</label>
                  <input
                    class="form-control rounded-pill"
                    type="text"
                    placeholder="Digite seu CPF ou CNPJ"
                    formControlName="cpf_cnpj"
                    (input)="onCpfCnpjInput($event)"
                    maxlength="18"
                  />
                  <div
                    *ngIf="
                      registerForm.controls.cpf_cnpj.touched &&
                      registerForm.controls.cpf_cnpj.errors?.required
                    "
                    class="text text-danger mt-1"
                  >
                    CPF ou CNPJ é obrigatório
                  </div>
                </div>
                <div class="form-group col-md-6 mb-4">
                  <label class="col-form-label">Rua</label>
                  <input
                    class="form-control rounded-pill"
                    type="text"
                    placeholder="Digite sua rua"
                    formControlName="rua"
                    required
                  />
                  <div
                    *ngIf="
                      registerForm.controls.rua.touched &&
                      registerForm.controls.rua.errors?.required
                    "
                    class="text text-danger mt-1"
                  >
                    Rua é obrigatória
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="form-group col-md-6 mb-4">
                  <label class="col-form-label">Número</label>
                  <input
                    class="form-control rounded-pill"
                    type="text"
                    placeholder="Digite o número"
                    formControlName="numero"
                    required
                  />
                  <div
                    *ngIf="
                      registerForm.controls.numero.touched &&
                      registerForm.controls.numero.errors?.required
                    "
                    class="text text-danger mt-1"
                  >
                    Número é obrigatório
                  </div>
                </div>
                <div class="form-group col-md-6 mb-4">
                  <label class="col-form-label">Bairro</label>
                  <input
                    class="form-control rounded-pill"
                    type="text"
                    placeholder="Digite o bairro"
                    formControlName="bairro"
                    required
                  />
                  <div
                    *ngIf="
                      registerForm.controls.bairro.touched &&
                      registerForm.controls.bairro.errors?.required
                    "
                    class="text text-danger mt-1"
                  >
                    Bairro é obrigatório
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="form-group col-md-6 mb-4">
                  <label class="col-form-label">Cidade</label>
                  <input
                    class="form-control rounded-pill"
                    type="text"
                    placeholder="Digite a cidade"
                    formControlName="cidade"
                    required
                  />
                  <div
                    *ngIf="
                      registerForm.controls.cidade.touched &&
                      registerForm.controls.cidade.errors?.required
                    "
                    class="text text-danger mt-1"
                  >
                    Cidade é obrigatória
                  </div>
                </div>
                <div class="form-group col-md-6 mb-4">
                  <label class="col-form-label">Senha</label>
                  <div class="position-relative">
                    <input
                      class="form-control rounded-pill pr-5"
                      [type]="show ? 'text' : 'password'"
                      formControlName="senha"
                      required
                      placeholder="Digite sua senha"
                      style="padding-right: 2.5rem"
                    />
                    <span
                      (click)="showPassword()"
                      style="
                        position: absolute;
                        top: 50%;
                        right: 18px;
                        transform: translateY(-50%);
                        cursor: pointer;
                        color: #888;
                      "
                    >
                      <i [ngClass]="show ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                    </span>
                  </div>
                  <div
                    *ngIf="
                      registerForm.controls.senha.touched &&
                      registerForm.controls.senha.errors?.required
                    "
                    class="text text-danger mt-1"
                  >
                    Senha é obrigatória
                  </div>
                  <div
                    *ngIf="
                      registerForm.controls.senha.touched &&
                      registerForm.controls.senha.errors?.minlength
                    "
                    class="text text-danger mt-1"
                  >
                    Senha deve ter no mínimo 6 caracteres
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="form-group col-md-6 mb-4">
                  <label class="col-form-label">Confirmar Senha</label>
                  <div class="position-relative">
                    <input
                      class="form-control rounded-pill pr-5"
                      [type]="showConfirm ? 'text' : 'password'"
                      formControlName="confirmarSenha"
                      required
                      placeholder="Confirme sua senha"
                      style="padding-right: 2.5rem"
                    />
                    <span
                      (click)="showConfirmPassword()"
                      style="
                        position: absolute;
                        top: 50%;
                        right: 18px;
                        transform: translateY(-50%);
                        cursor: pointer;
                        color: #888;
                      "
                    >
                      <i
                        [ngClass]="
                          showConfirm ? 'fa fa-eye-slash' : 'fa fa-eye'
                        "
                      ></i>
                    </span>
                  </div>
                  <div
                    *ngIf="
                      registerForm.controls.confirmarSenha.touched &&
                      registerForm.controls.confirmarSenha.errors?.required
                    "
                    class="text text-danger mt-1"
                  >
                    Confirmação de senha é obrigatória
                  </div>
                  <div
                    *ngIf="
                      registerForm.controls.confirmarSenha.touched &&
                      registerForm.controls.confirmarSenha.errors
                        ?.passwordMismatch
                    "
                    class="text text-danger mt-1"
                  >
                    As senhas não coincidem
                  </div>
                </div>
              </div>

              <div class="form-group mb-0">
                <div class="text-end mt-3">
                  <button
                    class="btn btn-primary d-block w-100 rounded-pill"
                    [disabled]="!registerForm.valid"
                    (click)="register()"
                    type="button"
                  >
                    <span>Criar Conta</span>
                  </button>
                </div>
              </div>

              <p class="mt-4 mb-0">
                Já tem uma conta?
                <a [routerLink]="'/auth/login'" class="ms-2">Fazer Login</a>
              </p>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
